<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      :prohibit="prohibit"
      :designDisabled="designDisabled"
      :operateDisabled="operateDisabled"
      :tablePage="page"
      @reload="reload"
      @openEditSkuDialog="openEditSkuDialog"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openAmzSkuVisible="openAddPlan"
        :disabled="disabled"
        :prohibit="prohibit"
      >
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [BaseTable, EditLoading],
  components: { Main, PageHeader},
  props: {
    disabled: { type: Boolean, default: false },
    prohibit: { type: Boolean, default: false },
    designDisabled: { type: Boolean, default: false },
    operateDisabled: { type: Boolean, default: false },
    amzFirstDemandCode: { type: String, default: '' },
    isVcList: { type: Array, default: () => [] },
  },
  data() {
    return {
      usePage: true,
      loading: false,
      chooseAmzSkuVisible: false,
      addPlanOptions: {
        visible: false,
      },
      editSkuOpts: {
        visible: false,
        amzFirstDemandDetailCode: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(form) {
      if (!this.amzFirstDemandCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzFirstDemandDetailPageListApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
          ...form,
          ...this.page,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
    },

    openAddPlan() {
      if (!this.amzFirstDemandCode) {
        this.$message.warning('请先保存主信息')
      } else {
        this.addPlanOptions.visible = true
        this.addPlanOptions.title =
          this.$l('btn_text_select_product') || '选择产品'
      }
    },

    openEditSkuDialog({ pageType, code = '' }) {
      const types = {
        planningEditor: this.$l('dialog_title_planning_edit') || '企划编辑产品',
        operationsEditor:
          this.$l('dialog_title_operations_edit') || '运营编辑产品',
        detail: this.$l('dialog_title_product_details') || '产品详情',
      }

      this.editSkuOpts = {
        visible: true,
        title: types[pageType],
        amzFirstDemandDetailCode: code,
        disabled: pageType === 'detail',
        planningDisabled: pageType === 'planningEditor',
      }
    },

    async skuConfirm(data) {
      if (!data || !data.length) return

      if (this.loadingOpen()) return
      this.$api
        .ecomAmzFirstDemandDetailAddSaveApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
          details: data,
        })
        .then((res) => {
          this.loading = false
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.close()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async spuConfirm({ data }) {
      if (!data || !data.length) return
      const amzFirstDemandSpuCodeList = data.map((item) => {
        return item.amzFirstDemandSpuCode
      })
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .ecomAmzFirstDemandSpuDelApi({
            amzFirstDemandCode: this.amzFirstDemandCode,
            amzFirstDemandSpuCodeList,
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.close()
          })
      })
    },

    close() {
      this.chooseAmzSkuVisible = false
      this.getData()
      this.$emit('reset')
    },

    validate() {
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
.tag_div {
  border: 1px solid #dcdfe6;
  padding: 0px 7px 7px 7px;
  border-radius: 4px;
  min-height: 50px;
}
</style>
